import { render } from "./EditPostForm.vue?vue&type=template&id=36cbb383"
import script from "./EditPostForm.vue?vue&type=script&lang=js"
export * from "./EditPostForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "36cbb383"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('36cbb383', script)) {
    api.reload('36cbb383', script)
  }
  
  module.hot.accept("./EditPostForm.vue?vue&type=template&id=36cbb383", () => {
    api.rerender('36cbb383', render)
  })

}

script.__file = "src/components/training/EditPostForm.vue"

export default script